let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3j9YD")).then(() => parcelRequire('6Zku7'));